import { render } from "./customFunctionEdit.vue?vue&type=template&id=0c712c72&scoped=true"
import script from "./customFunctionEdit.vue?vue&type=script&lang=js"
export * from "./customFunctionEdit.vue?vue&type=script&lang=js"

import "./customFunctionEdit.vue?vue&type=style&index=0&id=0c712c72&scoped=true&lang=css"

import exportComponent from "/var/www/shortcodeMarket/clientdashboard/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c712c72"]])

export default __exports__